var map = {
	"./bronze.svg": "050f",
	"./clock.svg": "e947",
	"./gold.svg": "70c0",
	"./grain.svg": "1ed1",
	"./heart.svg": "d5ac",
	"./ice.svg": "45e6",
	"./silver.svg": "ad29",
	"./souls.svg": "d0d2",
	"./sword.svg": "9021",
	"./wood.svg": "5123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b165";